// extracted by mini-css-extract-plugin
export default {"ImageContainer":"SuccessContainer_ImageContainer__V9Tmi","Image":"SuccessContainer_Image__XiaCb","RedirectText":"SuccessContainer_RedirectText__RVQFC"};